module.exports = __webpack_public_path__ + "static/media/Icon_addison-white.a168a6a9.svg";